import * as React from "react";
const SvgDefault = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "#36383B", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 2.4h5.1v5.1H2zM8.9 2.4H14v5.1H8.9zM2 8.9h5.1V14H2zM8.9 8.9H14V14H8.9z" }));
export default SvgDefault;
